<template>
  <div id="videoPlayerContainer">
    <div class="videoHeader">
      <van-icon class="closebuttton" name="close" @click="close" />
    </div>
    <video :src="videoUrl" autoplay controls="controls" width="100%"></video>
  </div>
</template>
<script>
import { scanUrl } from "@/CommonDP/utils";
export default {
  data() {
    return {};
  },

  created() {
    const { f, n } = this.$route.query;
    document.title = n;
    this.videoUrl = scanUrl(f, "");
  },

  methods: {
    close() {
      history.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
#videoPlayerContainer {
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 3;
  .videoHeader {
    height: 30px;
    background: #ffffff;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    .closebuttton {
      float: right;
      margin: 5px 5px 0 0;
    }
  }
}
</style>
